import { render, staticRenderFns } from "./DeptListTable.vue?vue&type=template&id=1f4d98f6&scoped=true"
import script from "./DeptListTable.vue?vue&type=script&lang=js"
export * from "./DeptListTable.vue?vue&type=script&lang=js"
import style0 from "./DeptListTable.vue?vue&type=style&index=0&id=1f4d98f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4d98f6",
  null
  
)

export default component.exports